<template>
    <div>
        <b-modal id="modal-reset-password" title="Reset Password Nasabah" centered no-close-on-backdrop no-close-on-esc hide-footer>
            Lakukan reset password untuk nasabah bernama {{ nasabah.nama }} (No. Anggota {{ nasabah.no }})? Password akan diubah kembali menjadi tanggal lahir nasabah!
            <div class="mt-2 text-right">
                <b-btn variant="pgiBtn" :disabled="isSubmitting" @click="execResetPassword()">
                    {{ isSubmitting ? "Memproses..." : "Reset" }}
                </b-btn>
            </div>
        </b-modal>
        <b-modal id="modal-reset-password-success" title="Reset Password Berhasil" centered no-close-on-backdrop no-close-on-esc hide-footer>
            Reset berhasil. Ingatkan kembali kepada nasabah bahwa password sekarang sesuai dengan tanggal lahir yang terdaftar pada sistem dengan format: <br />
            <strong>2 digit tanggal + 2 digit bulan + 2 digit belakang tahun</strong>
            <div class="mt-4">
                Anjurkan nasabah untuk segera melakukan pengubahan password ketika sudah masuk ke aplikasi.
            </div>
            <div class="mt-2 text-right">
                <b-btn variant="pgiBtn" @click="closeAllModals()">
                    OK
                </b-btn>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'modal-reset-password-anggota',
    props: {
        nasabah: { type: Object, required: true }
    },
    data() {
        return {
            isSubmitting: false
        }
    },
    methods: {

        execResetPassword() {

            let payload = new FormData()
            payload.append("nasabahId", this.nasabah.id)

            this.isSubmitting = true
            this.$axios.post("nasabah/reset-password", payload).then(() => {
                this.$bvModal.show("modal-reset-password-success")
            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => this.isSubmitting = false)

        },

        closeAllModals() {

            this.$bvModal.hide("modal-reset-password-success")
            this.$bvModal.hide("modal-reset-password")

        }

    }
}
</script>